<script>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import redeMarketingApi from '@/services/api/redeMarketingRepository'
import MembroDetalhesModal from './MembroDetalhesModal.vue'
import NoLinear from './NoLinear.vue'

export default {
  components: { MembroDetalhesModal, NoLinear },
  setup() {
    const route = useRoute()
    const membroIdInput = ref(1)
    const loading = ref(false)
    const noCentral = ref(null)
    const downline = ref([])
    const modalAberto = ref(false)
    const membroSelecionadoId = ref(null)

    const raiz = computed(() => {
      if (!noCentral.value) return null
      const root = {
        membroId: noCentral.value.membroId,
        nomeMembro: noCentral.value.nomeMembro,
        codigoIndicacao: noCentral.value.codigoIndicacao,
        nivel: 0,
        filhos: [],
      }
      const mapa = new Map()
      mapa.set(root.membroId, root)
      const nivelCentral = noCentral.value.nivel ?? 0
      const ordenada = [...downline.value].sort((a, b) => a.nivel - b.nivel)
      for (const n of ordenada) {
        const nodo = {
          membroId: n.membroId,
          nomeMembro: n.nomeMembro,
          codigoIndicacao: n.codigoIndicacao,
          nivel: n.nivel - nivelCentral,
          filhos: [],
        }
        mapa.set(nodo.membroId, nodo)
        const pai = mapa.get(n.patrocinadorId)
        ;(pai || root).filhos.push(nodo)
      }
      return root
    })

    async function carregar() {
      if (!membroIdInput.value) return
      loading.value = true
      try {
        const [noResp, downResp] = await Promise.all([
          redeMarketingApi.BuscarNo(membroIdInput.value),
          redeMarketingApi.Downline(membroIdInput.value),
        ])
        noCentral.value = noResp.data
        downline.value = downResp.data
      } catch (e) {
        console.error(e)
        noCentral.value = null
      } finally {
        loading.value = false
      }
    }

    function abrirDetalhes(id) {
      membroSelecionadoId.value = id
      modalAberto.value = true
    }

    watch(
      () => route.params.membroId,
      (v) => {
        if (v) {
          membroIdInput.value = Number(v)
          carregar()
        }
      },
    )

    onMounted(() => {
      if (route.params.membroId) membroIdInput.value = Number(route.params.membroId)
      carregar()
    })

    return { membroIdInput, loading, raiz, modalAberto, membroSelecionadoId, carregar, abrirDetalhes }
  },
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
      <div class="d-flex align-items-center gap-2">
        <router-link to="/rede-marketing" class="btn btn-sm btn-light">
          <i class="material-icons align-middle">arrow_back</i>
        </router-link>
        <h3 class="mb-0">Rede Linear</h3>
      </div>
      <div class="d-flex gap-2">
        <input v-model.number="membroIdInput" type="number"
               placeholder="ID raiz" class="form-control form-control-sm" style="width:120px;"
               @keyup.enter="carregar" />
        <button class="btn btn-sm btn-primary" @click="carregar" :disabled="loading">
          <i class="material-icons align-middle" style="font-size: 18px;">search</i>
        </button>
      </div>
    </div>

    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary"></div>
    </div>

    <div v-else-if="!raiz" class="alert alert-warning">
      <i class="material-icons align-middle me-1">search_off</i>
      Nenhum membro encontrado com esse ID.
    </div>

    <div v-else class="card">
      <div class="card-body">
        <NoLinear :no="raiz" :expandido-inicial="true" @clicar="abrirDetalhes" />
      </div>
    </div>

    <MembroDetalhesModal :visible="modalAberto" :membro-id="membroSelecionadoId" @fechar="modalAberto = false" />
  </div>
</template>
